// Rendered when WordApi 1.4 is not supported (older Word, Word on web on some
// tenants, or when opened outside Word entirely). Per SPEC-029 we only detect
// and inform — no degraded /review/file uploader here (OQ-06 / NG6).

import { BrandLockup } from '../brand'
import { t } from '../i18n'

export function UnsupportedNotice() {
  return (
    <main className="pane">
      <header className="pane-head">
        <h1>
          <BrandLockup compact />
        </h1>
      </header>
      <section className="card">
        <p>
          {t(
            'Ця версія Word не підтримує потрібні можливості (WordApi 1.4). Панель ревю недоступна.',
          )}
        </p>
        <p className="muted">
          {t('Скористайтеся веб-кабінетом і завантажте документ для перевірки файлом.')}
        </p>
      </section>
    </main>
  )
}
